
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M18 14C18 10.91 14.4 6.12001 12.77 4.13001C12.37 3.64001 11.62 3.64001 11.22 4.13001C10.76 4.70001 10.14 5.49001 9.48998 6.40001L17.93 14.84C17.97 14.56 18 14.28 18 14ZM19.29 19.01L6.11998 5.84001C5.72998 5.45001 5.09998 5.45001 4.70998 5.84001C4.31998 6.23001 4.31998 6.86001 4.70998 7.25001L7.31998 9.86001C6.54998 11.33 5.99998 12.79 5.99998 14C5.99998 17.31 8.68998 20 12 20C13.52 20 14.9 19.43 15.95 18.5L17.87 20.42C18.26 20.81 18.89 20.81 19.28 20.42C19.68 20.04 19.68 19.4 19.29 19.01Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-format-color-reset`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconFormatColorReset

    ```js
    <b-new-b-icon-format-color-reset />
    ```
</docs>


